export const enviroment = {
    niquelVersion: '2.23.11c',
    apiVersion: 'v1',
    apiUrl: process.env.REACT_APP_API_URL
};
